import * as o from "react";
import r from "../lib/IconBase.es.js";
import m from "../defs/Layout.es.js";
const t = o.forwardRef((a, e) => /* @__PURE__ */ o.createElement(r, { ref: e, ...a, weights: m }));
t.displayName = "LayoutIcon";
const n = t;
export {
  n as Layout,
  t as LayoutIcon
};
